<div class="modal-header shadow-sm">
    <h6 class="modal-title" id="exampleModalLabel">
        {{ title }}
    </h6>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      [disabled]="dismissControlsDisabled"
      (click)="onHeaderClose()"
    ></button>
</div>
<div class="modal-body scrollbar-primary thin">
    <form [formGroup]="configurationForm" autocomplete="off">
        <div *ngIf="loading && !configurations.length">
            <app-loader [loader]="loading"></app-loader>
        </div>
        <div formArrayName="configurations">
            <ng-container *ngFor="let config of configurations.controls; let i = index">
            <div class="row mb-3" *ngIf="shouldShowConfiguration(config)" [formGroupName]="i"
                [ngSwitch]="config.get('type')?.value">
                <div class="col-6">
                    <div class="d-flex flex-column">
                        <p class="mb-0 fw-bold" *ngIf="config.get('title')?.value !== 'Watch Theme'">{{config.get('title')?.value}}</p>
                        <span class="fs-1" *ngIf="config.get('title')?.value !== 'Watch Theme'">{{config.get('description')?.value}}</span>
                    </div>
                </div>
                <div class="col-6">
                    <!--<div *ngIf="config.get('code')?.value === CONFIGURATION_CODE.WATCH_THEME">
                        @if (isWatchThemeLocked(config)) {
                          <div class="form-control bg-light d-flex align-items-center">
                            {{ themeDisplayName(config.get('value')?.value) }}
                          </div>
                          <div class="fs-1 d-flex align-items-start gap-1 mt-1">
                            <i-bs
                              name="info-circle"
                              height="0.75rem"
                              width="0.75rem">
                            </i-bs>
                            <span>It has been inherited from the organization's theme configuration.</span>
                          </div>
                        } @else {
                        <mdb-form-control>
                            <mdb-select
                                formControlName="value"
                                [filter]="false"
                                (valueChange)="receiveThemeValue($event, config)"
                            >
                                <mdb-option *ngFor="let theme of availableThemes" [value]="theme.uniqueKey">
                                    {{ theme.name }}
                                </mdb-option>
                            </mdb-select>
                        </mdb-form-control>
                        <div class="fs-1 d-flex align-items-start gap-1 mt-1">
                          <i-bs
                            name="info-circle"
                            height="0.75rem"
                            width="0.75rem">
                          </i-bs>

                          <span>{{ themeHelpText(config.get('value')?.value) }}</span>
                        </div>
                        @if (excludedThemeNames.length) {
                          <span class="fs-1 d-block mt-1">
                            Pending Build and Retired themes are deliberately absent from this list —
                            @for (name of excludedThemeNames; track name; let i = $index) {
                              @if (i > 0 && i === excludedThemeNames.length - 1) {
                                <span> and </span>
                              } @else if (i > 0) {
                                <span>, </span>
                              }
                              <span class="link-primary"><strong>{{ name }}</strong></span>
                            }
                            are not offered.
                          </span>
                        }
                        }
                    </div>-->
                    <ng-container *ngIf="config.get('code')?.value !== CONFIGURATION_CODE.WATCH_THEME" [ngSwitch]="config.get('type')?.value">
                    <div *ngSwitchCase="inputType.BOOLEAN">
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" [id]="config.get('code')?.value"
                                formControlName="value">
                        </div>
                    </div>
                    <div *ngSwitchCase="inputType.UNIT">
                        <ng-container [ngSwitch]="config.get('metadata')?.value?.unitType?.type">
                            <div *ngSwitchCase="unitType.PERCENTAGE">
                                <div class="d-flex flex-column">
                                    <input
                                        class="form-control"
                                        type="text"
                                        [id]="config.get('code')?.value"
                                        formControlName="value"
                                        mask="0*.0*"
                                        [validation]="false"
                                        (change)="validateLimit(config.get('code')?.value)"
                                        suffix="%"
                                        [style.border]="invalidFields.includes(config.get('code')?.value) ? '1px solid red' : 'none'"
                                        >
                                    <span *ngIf="config.get('metadata')?.value?.note" class="fs-1">
                                        <i-bs name="info-circle" height="0.75rem" width="0.75rem"></i-bs>
                                            {{config.get('metadata')?.value?.note}}
                                    </span>
                                    <small *ngIf="invalidFields.includes(config.get('code')?.value)" class="text-danger">{{ config.get('title')?.value }} should not exceed 100%.</small>
                                </div>
                            </div>
                            <div *ngSwitchCase="unitType.TIME">
                                <div class="d-flex flex-column" *ngIf="isMinuteTimeField(config.get('code')?.value) || isHourTimeField(config.get('code')?.value); else defaultTimeInputs">
                                    <div class="input-group">
                                        <input
                                            class="form-control"
                                            type="text"
                                            [id]="config.get('code')?.value"
                                            maxlength="9"
                                            formControlName="value"
                                            mask="separator.2"
                                            thousandSeparator=""
                                            decimalMarker="."
                                            [dropSpecialCharacters]="false"
                                            [leadZero]="true"
                                            [validation]="false"
                                            >
                                        <span class="input-group-text bg-light">{{ timeFieldSuffix(config) }}</span>
                                    </div>
                                    <span *ngIf="config.get('metadata')?.value?.note" class="fs-1"><i-bs
                                        name="info-circle" height="0.75rem" width="0.75rem"></i-bs>
                                        {{config.get('metadata')?.value?.note}}
                                    </span>
                                    <small *ngIf="isOver24HourThreshold(config)" class="text-warning mt-1">
                                        Over 24 hours delays safety alerts. Confirm this is intentional.
                                    </small>
                                </div>
                                <ng-template #defaultTimeInputs>
                                    <div class="input-group">
                                        <input
                                            class="form-control"
                                            type="text"
                                            [id]="config.get('code')?.value"
                                            formControlName="value"
                                            mask="0*.0*"
                                            [validation]="false"
                                            >
                                        <span class="input-group-text bg-light">{{ timeFieldSuffix(config) }}</span>
                                    </div>
                                    <span *ngIf="config.get('metadata')?.value?.note" class="fs-1"><i-bs
                                            name="info-circle" height="0.75rem" width="0.75rem"></i-bs>
                                        {{config.get('metadata')?.value?.note}}
                                    </span>
                                </ng-template>
                            </div>
                            <div class="input-group" *ngSwitchCase="unitType.STRING">
                                <input class="form-control" type="text" [id]="config.get('code')?.value"
                                    formControlName="value">
                            </div>
                        </ng-container>
                    </div>
                    <div *ngSwitchCase="inputType.STRING">
                        <div class="input-group" *ngIf="config.get('code')?.value !== CONFIGURATION_CODE.RAPID_RESPONSE_CONTACT_PHONE; else rapidResponsePhoneInput">
                            <input class="form-control" type="text" [id]="config.get('code')?.value"
                                formControlName="value">
                        </div>
                        <ng-template #rapidResponsePhoneInput>
                            <div class="input-group">
                                <input
                                    class="form-control"
                                    type="text"
                                    [id]="config.get('code')?.value"
                                    formControlName="value"
                                    [mask]="phoneMask"
                                    [validation]="false"
                                />
                            </div>
                        </ng-template>
                    </div>
                    <div *ngSwitchCase="'Number'">
                        <div class="input-group">
                            <input class="form-control" type="number" [id]="config.get('code')?.value"
                                formControlName="value">
                        </div>
                    </div>
                    </ng-container>
                </div>
            </div>
            </ng-container>
        </div>
    </form>
</div>
<div class="modal-footer pt-0 d-flex justify-content-between">
    <button type="button" class="btn btn-gray-light" [disabled]="dismissControlsDisabled" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-primary d-flex align-items-center" [disabled]="loading || invalidFields.length > 0" (click)="linkDevice()">{{ confirmButtonLabel }}</button>
</div>
